import { ACTIVITY_TOGGLE_HISTORY } from "./constants";

export const toggleActivityHistory = () => dispatch => {
    dispatch({ type: ACTIVITY_TOGGLE_HISTORY });
};